import PermissionService from './permission.service';
import configService from './config.service';
export const getFeature = (name) => {
    const { FeatureFlags } = configService;
    const featureFlagValue = FeatureFlags[name] === undefined || FeatureFlags[name];
    const permissionService = new PermissionService();
    const recipientTypes = ['createAlertsPageSmsOptIn'];
    if (recipientTypes.includes(name)) {
        return featureFlagValue && !permissionService.permissions.usesNextGenSendingEngine();
    }
    return featureFlagValue;
};
export default {
    getFeature,
};
